/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import CropSquareIcon from '@mui/icons-material/CropSquare';

import { useNavigate } from 'react-router-dom';

import { DocsSections } from '../types';

interface Props {
  active: string | null;
  setActive: React.Dispatch<string | null>;
  link: DocsSections['subsections'][0] & {
    icon?: string | React.ReactNode;
  };
}

const List = styled.div<{ active: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  user-select: none;
  color: ${({ active, theme }) => (active ? theme.primary : theme.text.standard)};
  background-color: ${({ active, theme }) => (active ? theme.background.primary : 'transparent')};
  font-weight: 500;
  border-radius: 5px;
  padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(1)}`};
  padding-left: 2.4rem;

  font-size: 14px;
  font-family: 'Inter';

  svg {
    font-size: 1.8ch;
  }

  #icon {
    margin-right: 0.5rem;
  }

  &:last-of-type {
    margin-bottom: 0.5rem;
  }

  &:hover {
    cursor: pointer;
    background-color: ${({ active, theme }) => (active ? theme.background.primary : theme.background.secondary)};

    &::before {
      background-color: ${({ active, theme }) => (active ? theme.primary : '#d0d3d6')};
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 12.5px;
    top: 0;
    bottom: 0;
    width: 1.5px;
    background-color: ${({ active, theme }) => (active ? theme.primary : theme.line.light)};
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 0.35rem;
  gap: 0.8rem;
  padding: 8px 0;
  margin-top: 8px;

  &:first-of-type {
    margin-top: 4px;
  }

  svg {
    font-size: 1.8ch;
    color: #dfe0e2;
  }

  p {
    font-size: 0.7rem;
    font-weight: 500;
    text-transform: uppercase;
    color: #6f7e8c;
  }

  &::before {
    content: '';
    position: absolute;
    left: 7px;
    top: 0;
    bottom: 0;
    margin-top: 1.5rem;
    width: 1.5px;
    background-color: ${({ theme }) => theme.line.light};
  }
`;

export const Route: React.FC<Props> = ({ active, setActive, link }) => {
  const navigate = useNavigate();
  const itemRef = useRef<HTMLDivElement>(null);

  // Scroll into view when this route becomes active
  useEffect(() => {
    if (active === link.href && itemRef.current) {
      // First scroll attempt after a longer delay
      const firstScroll = setTimeout(() => {
        itemRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 300);

      // Second scroll attempt to ensure it stays in view
      const secondScroll = setTimeout(() => {
        itemRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 600);

      return () => {
        clearTimeout(firstScroll);
        clearTimeout(secondScroll);
      };
    }
  }, [active, link.href]);

  const changeDocument = () => {
    setActive(link.href);
    if (link?.href) navigate(link.href);
  };

  if (link.dividor) {
    return (
      <Divider>
        <div>
          <CropSquareIcon htmlColor='#dfe0e2' />
        </div>
        <p style={{ cursor: 'text' }}>{link.name}</p>
      </Divider>
    );
  }

  return (
    <List ref={itemRef} active={active === link.href} onClick={changeDocument}>
      <div>
        {link?.icon ? <span id='icon'>{link.icon}</span> : null}
        {active === link.href ? <span>{link.name}</span> : <span style={{ cursor: 'pointer' }}>{link.name}</span>}
      </div>
    </List>
  );
};
